import {
  PARTNER,
  publishedScope,
  systemAccountOrg,
} from "@/remote/companyScope";
import { isEmbedded } from "@/remote/contract";
import {
  adoptCustomerOrganisation,
  adoptMspOrganisation,
} from "@/utils/navigation/organisationNavigation";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

/** Where an embedded boot lands, from the company the host scoped the app to; null standalone, and
 * null when it published none. Sets the store too — the landing pages read that, not the route. */
export const embeddedCompanyLanding = async (): Promise<string | null> => {
  if (!isEmbedded()) return null;

  try {
    const published = publishedScope();
    if (!published) return null;

    // `/system/<uuid>` IS this company's page; forcing `/msp/<uuid>` 401s into a sign-out loop.
    if (systemAccountOrg() === published.organisationUuid) return null;

    const organisation = {
      id: published.organisationUuid,
      name: published.name || "",
    };

    if (published.type === PARTNER) {
      await adoptMspOrganisation(organisation);
      return buildOrgUrl("msp", organisation.id);
    }

    await adoptCustomerOrganisation(organisation);
    return buildOrgUrl("customer", organisation.id);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      "[titan] could not apply the host's company to this boot — landing on the signed-in " +
        "account's own scope instead.",
      error,
    );
    return null;
  }
};

export default embeddedCompanyLanding;
